export type PlanAddonKey = 'grabber' | 'mailer' | 'debouncer' | 'stripe';

export interface PlanAddonOption {
  key: PlanAddonKey;
  name: string;
  description: string;
  priceEur: number;
}

export const PLAN_ADDON_OPTIONS: PlanAddonOption[] = [
  {
    key: 'grabber',
    name: 'Grabber',
    description: 'Génération automatique de listes de domaines',
    priceEur: 99,
  },
  {
    key: 'mailer',
    name: 'Mailer',
    description: "Envoi d'emails en masse avec gestion avancée",
    priceEur: 99,
  },
  {
    key: 'debouncer',
    name: 'Debouncer',
    description: 'Validation en masse de listes email',
    priceEur: 300,
  },
  {
    key: 'stripe',
    name: 'Stripe',
    description: 'Recheck, cashout Express et transfert de solde Stripe',
    priceEur: 300,
  },
];

const CRYPTO_BASE_99_EUR: Record<'BTC' | 'ETH' | 'SOL', number> = {
  BTC: 0.0025,
  ETH: 0.035,
  SOL: 0.85,
};

export const getAddonCryptoAmount = (
  priceEur: number,
  crypto: 'BTC' | 'ETH' | 'SOL'
): number => {
  const factor = priceEur / 99;
  const value = CRYPTO_BASE_99_EUR[crypto] * factor;
  return Number(value.toFixed(crypto === 'BTC' ? 6 : 4));
};

export const formatAddonEur = (amount: number): string =>
  new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(amount);

export const createEmptyAddonSelection = (): Record<PlanAddonKey, boolean> => ({
  grabber: false,
  mailer: false,
  debouncer: false,
  stripe: false,
});

export const getSelectedAddonKeys = (
  selection: Record<PlanAddonKey, boolean>
): PlanAddonKey[] =>
  (Object.entries(selection) as [PlanAddonKey, boolean][])
    .filter(([, selected]) => selected)
    .map(([key]) => key);

export const getSelectedAddonsCryptoTotal = (
  selection: Record<PlanAddonKey, boolean>,
  crypto: 'BTC' | 'ETH' | 'SOL'
): number => {
  let total = 0;
  for (const addon of PLAN_ADDON_OPTIONS) {
    if (selection[addon.key]) {
      total += getAddonCryptoAmount(addon.priceEur, crypto);
    }
  }
  return Number(total.toFixed(crypto === 'BTC' ? 6 : 4));
};

export const getSelectedAddonsEurTotal = (
  selection: Record<PlanAddonKey, boolean>
): number =>
  PLAN_ADDON_OPTIONS.reduce(
    (sum, addon) => sum + (selection[addon.key] ? addon.priceEur : 0),
    0
  );
